const cart = {
    isActivePage: () => /cart\.carparts\.com/.test(window.location.hostname) && /\/basket\/?$/.test(window.location.pathname),
    hasDeletedItem: () => /(\?|&)deleteitem=/.test(window.location.search),
    hasAddedItem: () => /(\?|&)ai=true/.test(window.location.search)
}

export default cart



// WEBPACK FOOTER //
// ./non-pwa/pages/cart.js